export const environment = process.env.VUE_APP_ENVIRONMENT
export const API_V2_PREFIX = '/api/v2'
